import BookFreeClassBtn from '@components/common/book-free-class-btn'

type Props = {
  title: string
  urlQuery?: string
}

const FixedMobileCTA = ({ title, urlQuery }: Props) => {
  return (
    <div
      className="flex lg:hidden fixed w-full bottom-0 left-0 items-center space-x-4 bg-white p-4"
      style={{ boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.1)', zIndex: 1001 }}
    >
      <p className="w-48 font-600 text-grey">{title}</p>
      <BookFreeClassBtn className="h-full" query={urlQuery} />
    </div>
  )
}
export default FixedMobileCTA
